import { createClient } from '@supabase/supabase-js'
import type { Database } from '@/types/database'

// .trim() defends against a stray trailing newline/space in the env value (e.g. a
// key pasted into the Vercel dashboard with a newline). REST tolerates it because
// fetch trims header values, but the Realtime WebSocket puts the key in the URL
// (?apikey=…%0A) and the server rejects it ("no valid credentials"). Trim → clean.
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL?.trim()
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY?.trim()

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables')
}

export const supabase = createClient<Database>(supabaseUrl, supabaseAnonKey)

// Edge function URL helper — avoids hardcoding the Supabase URL throughout the codebase
export function edgeFn(name: string): string {
  return `${supabaseUrl}/functions/v1/${name}`
}
